import { FC } from 'react';
// import { ReactComponent as PreviewIcon } from '../../assets/chart-preview-icon.png';
import { Tooltip } from '../Tooltip/Tooltip';

type PreviewButtonProps = {
  onClick: () => void;
  title?: string;
};

export const PreviewButton: FC<PreviewButtonProps> = ({ title = 'Preview Download', onClick }) => {
  return (
    <div className="flex justify-center items-center ml-2 w-12">
      <Tooltip title={title}>
        <div
          className={`cursor-pointer border rounded-[0.8rem] group bg-white transition-all hover:bg-slate-200 p-[0.2rem]`}
          onClick={onClick}
        >
          <img
            src="/assets/chart-preview-icon.png"
            className="w-20 transition-all fill-black group-hover:fill-white"
          />
        </div>
      </Tooltip>
    </div>
  );
};
